"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const useFlatListItemWrapperStyle = (control, numColumns) => {
    var _a, _b, _c;
    return (0, react_1.useMemo)(() => {
        var _a, _b, _c;
        let styleGrid = {};
        if (numColumns) {
            const percentage = 100 / numColumns;
            if (percentage > 0) {
                styleGrid = { width: `${percentage}%` };
            }
        }
        if (control.isHorizontal) {
            styleGrid = {
                width: undefined,
            };
        }
        return Object.assign({ width: '100%', alignItems: ((_a = control.contentContainerStyle) === null || _a === void 0 ? void 0 : _a.alignItems) || undefined, flexDirection: ((_b = control.contentContainerStyle) === null || _b === void 0 ? void 0 : _b.flexDirection) || undefined, justifyContent: ((_c = control.contentContainerStyle) === null || _c === void 0 ? void 0 : _c.justifyContent) || undefined }, styleGrid);
    }, [
        (_a = control.contentContainerStyle) === null || _a === void 0 ? void 0 : _a.alignItems,
        (_b = control.contentContainerStyle) === null || _b === void 0 ? void 0 : _b.flexDirection,
        (_c = control.contentContainerStyle) === null || _c === void 0 ? void 0 : _c.justifyContent,
        numColumns,
        control.isHorizontal,
    ]);
};
exports.default = useFlatListItemWrapperStyle;
